import React , {useState} from 'react';
import PropTypes from 'prop-types';
import './styles.scss'
import AboutItem from './about-item';

About.propTypes = {
    data : PropTypes.array,
};

function About(props) {

    const {data} = props;

    const [dataBlock] = useState(
        {
            subtitle : 'Our Services',
            title: 'Game-Ready Solutions for Your Vision',
            desc : 'Explore a comprehensive range of game development services tailored to transform your ideas into immersive web3 gaming experiences. Our offerings encompass end-to-end game development, from initial concept to launch, covering programming, concept art, 3D art, and optimization. Additionally, benefit from expert Game-Fi consulting to shape your web3 game ecosystem with strategic insights into tokenomics, venture design, and growth/community strategies. Need to amplify your development team? Our plugin team of over 30 skilled professionals stands ready to provide immediate capacity and talent to gaming studios, ensuring seamless expansion.'
        }
    )

    return (
        <section className="tf-section tf-about">
            <div className="container">
                <div className="row">
                    <div className="col-xl-5 col-md-12">
                        <div className="content-about mobie-40" data-aos="fade-up" data-aos-duration="800">
                            <div className="tf-title st2">
                                <p className="h8 sub-title">{dataBlock.subtitle}</p>
                                <h4 className="title">{dataBlock.title}</h4>
                            </div>
                            <p>{dataBlock.desc}</p>
                                
                        </div>
                    </div>
                    <div className="col-xl-7 col-md-12">
                        <div className="wrap-about" data-aos="fade-up" data-aos-duration="800">
                            {
                                data.map(item => (
                                    <AboutItem key={item.id} item={item} />
                                ))
                            }
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default About;